import { NgModule } from "@angular/core";

// xplat
import { MypCoreModule } from "@mypxplat/xplat/web/core";

@NgModule({
  imports: [MypCoreModule],
})
export class CoreModule {}
